<template>
  <div>
    <b-alert
      class="position-fixed fixed-top m-0 rounded-0 text-center"
      fade
      :show="dismissCountDown"
      :variant="errorMessage.color"
      @dismissed="dismissed"
      >{{ errorMessage.text }}</b-alert
    >
    <div class="teste d-none d-sm-block">
      <div class="teste2">
        <img
          src="@/assets/project_create_illo_welcome@2x.png"
          class="teste3"
          fluid
        />
      </div>
    </div>
    <header class="bg-light">
      <div class="container py-4">
        <h1 class>Crédito Imobiliário CAIXA</h1>
        <h6 class="lead">Crie sua proposta de forma rápida e descomplicada.</h6>
      </div>
    </header>
    <div class="container py-3">
      <div class="row">
        <div class="col-md-4 col-sm-12">
          <div>
            <blockquote class="blockquote" id="subTitle">
              <p class="mb-0">Diga-nos sobre o imóvel pretendido.</p>
              <footer class="blockquote-footer">Estamos quase lá!</footer>
            </blockquote>
          </div>
        </div>
        <div class="col-md-5 col-sm-12">
          <div class="form-group">
            <b-form-select
              size="sm"
              :options="optionsPropertyType"
              :class="{ 'is-invalid': $v.proposal.propertyType.$error }"
              v-model.lazy="$v.proposal.propertyType.$model"
            ></b-form-select>
            <small
              class="text-danger"
              v-if="
                !$v.proposal.propertyType.required &&
                  $v.proposal.propertyType.$error
              "
              ><em>Campo obrigatório</em></small
            >

            <!--{{ proposal.propertyType }}-->
          </div>

          <div class="form-group">
            <b-form-select
              size="sm"
              :options="optionsPropertyCategory"
              :class="{ 'is-invalid': $v.proposal.propertyCategory.$error }"
              v-model.lazy="$v.proposal.propertyCategory.$model"
            ></b-form-select>
            <small
              class="text-danger"
              v-if="
                !$v.proposal.propertyCategory.required &&
                  $v.proposal.propertyCategory.$error
              "
              ><em>Valor deve ser maior que 5 dígitos</em></small
            >

            <!-- {{ proposal.propertyCategory }} -->
          </div>
          <div class="form-group">
            <small class="form-text text-muted mb-1"
              >Informe o valor de compra e venda do imóvel.</small
            >
            <currency-input
              class="mb-2 form-control form-control-sm"
              maxlength="8"
              currency="BRL"
              locale="pt"
              :class="{ 'is-invalid': $v.proposal.propertyValue.$error }"
              v-model.lazy="$v.proposal.propertyValue.$model"
            />
            <small
              class="text-danger"
              v-if="
                !$v.proposal.propertyValue.minLength &&
                  $v.proposal.propertyValue.$error
              "
              ><em>Valor deve ser maior que 5 dígitos</em></small
            >

            <!-- <b-form-input
              size="sm"
              placeholder="Valor Aproximado do Imóvel"
              class="mb-2"
              v-model="proposal.propertyValue"
              v-currency="{currency: 'BRL', locale: 'pt', precision: 2 }"
              maxlength="16"
            ></b-form-input>-->

            <!--<small class="form-text text-muted mb-1">Informe o valor de compra e venda do imóvel.</small>
                            <div class="input-group input-group-sm mb-2 mr-sm-2">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">R$</div>
                                </div>
                                <input type="text" class="form-control form-control-sm money" placeholder="Valor Aproximado do Imóvel" name="propertyValue" id="propertyValue"
                                    v-money="money" v-model="proposal.propertyValue" maxlength="16">
                            </div>
            {{ proposal.propertyValue }}-->
          </div>
          <div class="form-group">
            <small class="form-text text-muted mb-1"
              >Informe o valor de financiamento pretendido.</small
            >
            <currency-input
              class="mb-2 form-control form-control-sm"
              maxlength="8"
              currency="BRL"
              locale="pt"
              :class="{
                'is-invalid': $v.proposal.intendedFinancingValue.$error,
              }"
              v-model.lazy="$v.proposal.intendedFinancingValue.$model"
            />
            <small
              class="text-danger"
              v-if="
                !$v.proposal.intendedFinancingValue.minLength &&
                  $v.proposal.intendedFinancingValue.$error
              "
              ><em>Campo obrigatório</em></small
            >

            <!-- <b-form-input
              size="sm"
              placeholder="Valor Aproximado do Financiamento"
              class="mb-2"
              v-model="proposal.intendedFinancingValue"
              v-currency="{currency: 'BRL', locale: 'pt', precision: 2 }"
              maxlength="16"
            ></b-form-input>-->
            <!--<div class="input-group input-group-sm mb-2 mr-sm-2">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">R$</div>
                                </div>
                                <input type="text" class="form-control form-control-sm money" placeholder="Valor de Financiamento Pretendido" name="intendedFinancingAmount" id="intendedFinancingAmount"
                                    v-money="money" v-model="proposal.intendedFinancingValue" maxlength="16">
                            </div>
            {{ proposal.intendedFinancingAmount }}-->
          </div>
          <div class="form-group">
            <div class="form-row">
              <div class="col-4">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  placeholder="Prazo"
                  maxlength="3"
                  name="period"
                  id="period"
                  v-model="proposal.period"
                />
              </div>
              <!--{{ proposal.period }}-->
              <div class="col-4">
                <b-form-select
                  v-model="proposal.amortizationSystem"
                  :options="optionsAmortizationSystem"
                  size="sm"
                ></b-form-select>
              </div>
              <!--{{ proposal.amortizationSystem }}-->
              <div class="col-4">
                <b-form-select
                  v-model="proposal.indexer"
                  :options="optionsIndexer"
                  size="sm"
                ></b-form-select>
                <!-- {{ proposal.indexer }} -->
              </div>
            </div>
          </div>
          <div class="form-group">
            <vue-google-autocomplete
              ref="address"
              id="map"
              classname="form-control form-control-sm text-capitalize"
              placeholder="Localização do Imóvel"
              country="br"
              types= "geocode"
              size="sm"
              v-on:placechanged="getAddressData"
            >
              <!-- v-model="" -->
            </vue-google-autocomplete>
            <!-- <input
              type="text"
              class="form-control form-control-sm text-capitalize"
              id="propertyLocation"
              placeholder="Localização do Imóvel"
              name="propertyLocation"
              v-model="proposal.propertyLocation"
            /> -->
          </div>
          <div class="form-group">
            <textarea
              class="form-control form-control-sm"
              id="commentArea"
              name="commentArea"
              rows="3"
              placeholder="Alguma observação a fazer da proposta?"
              v-model="proposal.steps.note"
            ></textarea>
          </div>
          <Navigation
            :stepTwoValidations="validSecondStep"
            :isInvalid2="$v.$invalid"
          ></Navigation>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import Navigation from "./Navigation";
import { mask } from "vue-the-mask";
import { CurrencyInput } from "vue-currency-input";
import { required, minLength, email } from "vuelidate/lib/validators";
import VueGoogleAutocomplete from "vue-google-autocomplete";

// import { CurrencyDirective } from "vue-currency-input";

export default {
  data() {
    return {};
  },
  validations: {
    proposal: {
      propertyType: { required },
      propertyCategory: { required },
      propertyValue: { required, minLength: minLength(5) },
      intendedFinancingValue: { required, minLength: minLength(5) },
    },
  },
  components: {
    Navigation,
    CurrencyInput,
    VueGoogleAutocomplete,
  },
  computed: {
    ...mapState([
      "user",
      "proposal",
      "optionsPropertyCategory",
      "optionsPropertyType",
      "optionsAmortizationSystem",
      "optionsIndexer",
      "errorMessage",
      "dismissCountDown",
    ]),
  },
  mutations: {
    ...mapMutations(["setErrorMessage"]),
  },
  methods: {
    ...mapActions(["createProposal", "dismissed"]),
    getAddressData(addressData,placeResultData) {
      const sublocalityArr = placeResultData.address_components.filter((el) =>
        el.types.includes("sublocality")
      );
      const administrative_area_level_2Arr = placeResultData.address_components.filter(
        (el) => el.types.includes("administrative_area_level_2")
      );
      const administrative_area_level_1Arr = placeResultData.address_components.filter(
        (el) => el.types.includes("administrative_area_level_1")
      );
      this.proposal.propertyLocation = {
        sublocality:
          sublocalityArr && sublocalityArr.length
            ? sublocalityArr[0].long_name
            : "",
        administrative_area_level_2:
          administrative_area_level_2Arr &&
          administrative_area_level_2Arr.length
            ? administrative_area_level_2Arr[0].long_name
            : "",
        administrative_area_level_1:
          administrative_area_level_1Arr &&
          administrative_area_level_1Arr.length
            ? administrative_area_level_1Arr[0].long_name
            : "",
        country: addressData.country ? addressData.country : "",
        latitude: addressData.latitude ? addressData.latitude : "",
        locality: addressData.locality ? addressData.locality : "",
        longitude: addressData.longitude ? addressData.longitude : "",
        postal_code: addressData.postal_code ? addressData.postal_code : "",
        route: addressData.route ? addressData.route : "",
      };
    },
    validSecondStep() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$store.commit("setErrorMessage", {
          color: "danger",
          text: "Ops... Corrija os dados necessários para prosseguir.",
        });
      } else {
      }
    },
  },
  directives: {
    mask,
    // currency: CurrencyDirective
  },
};
</script>
<style scoped>
.teste {
  background-attachment: scroll;
  background-color: #039be5;
  /* background-image: url(images/grain@2x.png); */
  background-repeat: no-repeat;
  background-position: right bottom;
  background-size: 100% 100%;
  flex: 0 0 320px;
  height: 100%;
  /*min-height: 851px;*/
  position: absolute;
  position: fixed;
  right: 0;
  top: 0;
  width: 320px;
  z-index: 0;
}

.teste2 {
  /* height: 718px;*/
  pointer-events: none;
  position: absolute;
  position: fixed;
  right: 0px;
  /* top: 133px; */
  bottom: 0;
  width: 568px;
}

.teste3 {
  height: 80vh;
  position: absolute;
  width: 568px;
  bottom: 0;
  right: 10px;
  z-index: inherit;
}

.btn {
  font-size: 11px;
  padding: 8px 26px 6px;
  letter-spacing: 1.7px;
  text-transform: uppercase;
  border-radius: 2px;
  outline: none;
  -webkit-transition: 0.15s linear;
  transition: 0.15s linear;
}
.btn-primary {
  color: #fff;
  background-color: #50a1ff;
  border-color: #50a1ff;
}
</style>
